// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import type {AgentModelChoice} from '@fluxer/schema/src/domains/konvo/Agents';
import {makeAutoObservable} from 'mobx';

export const modelKey = (model: Pick<AgentModelChoice, 'provider' | 'model'>) =>
	`${model.provider}\u0000${model.model}`;

export type AgentModelTab = {kind: 'favourites'} | {kind: 'provider'; provider: string};

/**
 * The models starred in the agent model menu, in the order they were starred: the star tab at the
 * top of its rail lists them. Also remembers the last tab used. Local to this device.
 */
class AgentModelFavourites {
	keys: Array<string> = [];
	lastTab: AgentModelTab | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'AgentModelFavourites', ['keys', 'lastTab']);
	}

	setLastTab(tab: AgentModelTab): void {
		this.lastTab = tab.kind === 'favourites' ? {kind: 'favourites'} : {kind: 'provider', provider: tab.provider};
	}

	has(model: Pick<AgentModelChoice, 'provider' | 'model'>): boolean {
		return this.keys.includes(modelKey(model));
	}

	toggle(model: Pick<AgentModelChoice, 'provider' | 'model'>): void {
		const key = modelKey(model);
		this.keys = this.keys.includes(key) ? this.keys.filter((entry) => entry !== key) : [...this.keys, key];
	}
}

export default new AgentModelFavourites();
